import React from "react";
import { useMsal } from "@azure/msal-react";
import { Button } from "@mui/material";
import { loginRequest } from "../../authConfig";
import PersonIcon from '@mui/icons-material/Person';
import { StyledPersonIcon } from "./ButtonStyles";
/**
 * Renders a drop down button with child buttons for logging in with a popup or redirect
 */
export const SignInButton = () => {
    const { instance } = useMsal();

    const handleLogin = (loginType) => {
        if (loginType === "popup") {
            instance.loginPopup(loginRequest).catch(e => {
                console.log(e);
            });
        } else if (loginType === "redirect") {
            instance.loginRedirect(loginRequest).catch(e => {
                console.log(e);
            });
        }
    } 
    return (
        <>
   
        
        <StyledPersonIcon mx={1} />
        
        <Button id="basic-button" 
        variant ='contained'
        size='md'
        color='secondary'
        onClick={() => handleLogin("redirect")} 
        >Log in</Button>
        </>
 
        
      
    )
}